import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Text, Badge } from 'pcln-design-system'

const StyledBadge = styled(Badge)`
  max-height: 36px;
  font-size: 10px;
`

const StyledText = styled(Text)`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 116px;

  @media (min-width: 375px) {
    max-width: unset;
  }

  ${(props) =>
    props.isSBS &&
    `${props.theme.flyQueries.desktop} {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      max-width: 96px;
    }
    ${props.theme.flyQueries.desktoplg} {
      max-width: unset;
    }`}
`

const TravelBadge = ({ textColor, badgeColor, badgeCopy, showEllipsisText, isSBS }) => {
  return (
    <StyledBadge color={badgeColor} my={'auto'} mr={2}>
      {showEllipsisText ? (
        <StyledText fontSize={'10px'} caps isSBS={isSBS} color={textColor}>
          {badgeCopy}
        </StyledText>
      ) : (
        <Text fontSize={'10px'} caps color={textColor}>
          {badgeCopy}
        </Text>
      )}
    </StyledBadge>
  )
}

TravelBadge.defaultProps = {
  textColor: 'text.lightest',
  badgeColor: 'secondary.base',
  badgeCopy: 'No Change Fees',
  showEllipsisText: false,
  isSBS: false,
}
TravelBadge.propTypes = {
  textColor: PropTypes.string,
  badgeColor: PropTypes.string,
  badgeCopy: PropTypes.string,
  showEllipsisText: PropTypes.bool,
  isSBS: PropTypes.bool,
}

export default TravelBadge
